export enum LogType {
    SyncLogs = 'SyncLogs',
    MailListLogs = 'MailListLogs',
    ReadingPaneLogs = 'ReadingPaneLogs',
}
